import React from 'react'
import Input from './../input'
import { PROTOCOL, httpauth_src_fields, httpauth_dest_fields } from './../../lib/helper'
import { Form } from 'formsy-react'
import _ from 'underscore'
import PropTypes from 'prop-types'

class FlywheelForm extends React.Component {
	constructor(props){
		super(props)
		this.state = {privacyMode: true, sourceSiteInfo: false, httpAuth: false}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
		this.togglePrivacyMode = this.togglePrivacyMode.bind(this)
		this.toggleSourceSiteInfo = this.toggleSourceSiteInfo.bind(this)
		this.toggleTablesInfo = this.toggleTablesInfo.bind(this)
		this.toggleHttpAuth = this.toggleHttpAuth.bind(this)
		this.showDirectoryList = this.showDirectoryList.bind(this)
		this.showTablesList = this.showTablesList.bind(this)
	}

	componentWillMount(){
		const { errors } = this.props
		this.setAdvancedOptionsError(errors)
		this.setToggle()
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		const { errors } = nextProps
		const olderrors = this.props.errors
		if (!_.isEqual(errors, olderrors)){
			this.setAdvancedOptionsError(errors)
		}
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	setToggle() {
		const { fields } = this.props
		if (fields['selectedDirectories'] && fields['selectedDirectories'].length) {
			this.setState({sourceSiteInfo: true})
		}
		if (fields['httpauth_src_user'] || fields['httpauth_src_password']) {
			this.setState({httpAuth: true})
		}
	}

	togglePrivacyMode() {
		const { privacyMode } = this.state
		this.setState({privacyMode: !privacyMode})
	}

	toggleSourceSiteInfo() {
		const { sourceSiteInfo } = this.state
		this.setState({sourceSiteInfo: !sourceSiteInfo})
	}

	toggleTablesInfo() {
		const { tablesInfo } = this.state
		this.setState({tablesInfo: !tablesInfo})
	}

	toggleHttpAuth() {
		const { httpAuth } = this.state
		this.setState({httpAuth: !httpAuth})
	}

	setAdvancedOptionsError(errors){
		if (!_.isEmpty(_.intersection(errors, httpauth_src_fields))){
			this.setState({ httpAuth: true })
		} else if (!_.isEmpty(_.intersection(errors, httpauth_dest_fields))){
			this.setState({ privacyMode: true })
		}
	}

	showDirectoryList() {
		const { directoryList, changeSelection } = this.props
		if (directoryList){
			return directoryList.map((directory, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className="control control--checkbox">{directory.name}
						<input
							name={directory.name}
							type="checkbox"
							checked={directory.selected}
							onChange={changeSelection.bind(null, directory.name)}
							disabled={directory.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
		}
	}

	showTablesList() {
		const { tablesList, changeTableSelection } = this.props
		if (tablesList) {
			return tablesList.map((table, index) => {
				return <li key={index} style={{listStyle: "none"}}>
					<label className={`control control--checkbox ${table.isDisabled ? 'disabled' : ''}`}>{table.name}
						<input
							name={table.name}
							type="checkbox"
							checked={table.selected}
							onChange={changeTableSelection.bind(null, table.name)}
							disabled={table.isDisabled}
						/>
						<div className="control__indicator"></div>
					</label>
				</li>
			})
		}
	}

	render() {
		const { handleSubmit, error, getDirectoryList, fetchingDirectories, getTablesList, fetchingTables } = this.props
		const { privacyMode, sourceSiteInfo, tablesInfo, httpAuth } = this.state
		return <div className="fw d-flex no-touchevents">
			<div className="container">
				<div className="jumbotron">
					<img className="fw-logo" src="/assets/flywheel-migration.svg" alt=""/>
					<h1 className="fw-600">Migrate your site to Flywheel</h1>
					<p className="subhead">Don&apos;t have the time?{' '}
						<a href="https://app.getflywheel.com/migration" target="_blank">Let us migrate your site for free!</a>
					</p>
				</div>
				<hr/>
				<Form className="needs-validation" onSubmit={handleSubmit}>
					<div className="container-narrow">
						<h2 className="fw-600">Flywheel Information</h2>
						{ error && <div className="pb-2 font12">{error}</div> }
						<div className="row">
							<div className={this.getClassName('flypath')}>
								<Input
									id="fw-dashboard-url"
									type="text"
									title="Dashboard URL*"
									name="flypath"
									placeholder="E.g., https://app.getflywheel.com/user/site"
									classname=""
									value={this.fetchValue('flypath')}
									helpInfo={<span>Copy the URL in your browser&apos;s address bar when viewing your site&apos;s dashboard overview in the Flywheel app</span>}
								/>
							</div>
						</div>
						<div className="row">
							<div className={this.getClassName('newurl')}>
								<Input
									id="fw-temp-url"
									type="text"
									title="Temporary URL*"
									name="newurl"
									placeholder="E.g., https://random-name.flywheelsites.com"
									classname=""
									value={this.fetchValue('newurl')}
									helpInfo={<span>This is the primary URL of the destination site on Flywheel.
										This domain generally ends in &quot;flywheelsites.com&quot;.<br/>
										<a href="https://getflywheel.com/wordpress-support/what-is-a-temporary-url-and-how-do-i-change-it/" target="_blank">
											Read&nbsp;more</a>
									</span>}
								/>
							</div>
						</div>
						<div className="row">
							<div className={this.getClassName('username')}>
								<Input
									id="fw-username"
									type="text"
									title="Flywheel Username*"
									name="username"
									classname=""
									value={this.fetchValue('username')}
									helpInfo={<span>Found in <a href="https://app.getflywheel.com/profile" target="_blank">your&nbsp;profile</a>.<br/><br/>
										<strong>Note:</strong> this is your username, not your email address.
									</span>}
								/>
							</div>
						</div>
						<div className="row">
							<div className={this.getClassName('passwd')}>
								<Input
									id="fw-password"
									type="password"
									title="Flywheel Password*"
									name="passwd"
									classname=""
									value={this.fetchValue('passwd')}
									helpInfo={<span>Your <strong>Flywheel password</strong> (not the WordPress password)</span>}
								/>
							</div>
						</div>

						<label htmlFor="fw-password">
							Is privacy mode enabled?*
							<span className="tooltip">
								<img src="/assets/help.svg" className="tooltip__trigger" alt="" />
								<div className="tooltip__body">Find your Privacy Mode credentials on your site&apos;s dashboard, below the domains list.<br/>
									<a href="https://getflywheel.com/wordpress-support/why-are-my-sites-password-protected/" target="_blank">Read&nbsp;more</a>
								</div>
							</span>
						</label>
						<input type="radio" id="fw-pm-enabled-yes" name="fw-pm-enabled" checked={privacyMode} onChange={this.togglePrivacyMode}/>
						<label htmlFor="fw-pm-enabled-yes">Yes</label>
						<input type="radio" data-hide-next id="fw-pm-enabled-no" name="fw-pm-enabled" checked={!privacyMode} onChange={this.togglePrivacyMode}/>
						<label htmlFor="fw-pm-enabled-no">No</label>
						<div data-toggle-section>
							<div className="row">
								<div className={this.getClassName('httpauth_dest_user')}>
									<Input
										type="text"
										id="fw-pm-username"
										title="Privacy Mode Username"
										name="httpauth_dest_user"
										placeholder="Username (usually 'flywheel')"
										value={this.fetchValue('httpauth_dest_user')}
									/>
								</div>
							</div>
							<div className="row">
								<div className={this.getClassName('httpauth_dest_password')}>
									<Input
										type="password"
										id="fw-pm-password"
										title="Privacy Mode Password"
										name="httpauth_dest_password"
										placeholder="Password"
										value={this.fetchValue('httpauth_dest_password')}
									/>
								</div>
							</div>
						</div>
						<hr/>
						<div className="container-narrow">
							<h2 className="fw-600">Source site information</h2>
							<label>
								Any root directories you want to migrate?
								<span className="tooltip">
									<img src="/assets/help.svg" className="tooltip__trigger" alt="" />
									<div className="tooltip__body">By default, the plugin only moves the database, and files found in the wp-content directory.
										If you have any directories in the site root that also need to be moved over, select those.
									</div>
								</span>
							</label>

							<input type="radio" id="source-root-dir-yes" name="source-root-dir" checked={sourceSiteInfo} onClick={getDirectoryList} onChange={this.toggleSourceSiteInfo}/>
							<label className="radio" htmlFor="source-root-dir-yes">Yes</label>
							<input type="radio" data-hide-next id="source-root-dir-no" name="source-root-dir" checked={!sourceSiteInfo} onChange={this.toggleSourceSiteInfo}/>
							<label htmlFor="source-root-dir-no">No</label>

							<div className="mb-3" data-toggle-section>
								{fetchingDirectories && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading…"/>}
								{this.showDirectoryList()}
							</div>

							<label>
								Migrate additional database tables.
								<span className="tooltip">
									<img src="/assets/help.svg" className="tooltip__trigger" alt="" />
									<div className="tooltip__body">By default, this plugin only moves the database and files found in the wp-content directory.
										&nbsp;If you would like to bring over additional database tables that have transient data or plugin configurations (ex. caching information), select the additional tables below.
										&nbsp;This is not recommended for most WordPress installs as it can corrupt / bloat the destination environment.
									</div>
								</span>
							</label>

							<input type="radio" id="source-root-db-yes" name="source-root-db" checked={tablesInfo} onClick={getTablesList} onChange={this.toggleTablesInfo}/>
							<label className="radio" htmlFor="source-root-db-yes">Yes</label>
							<input type="radio" data-hide-next id="source-root-db-no" name="source-root-db" checked={!tablesInfo} onChange={this.toggleTablesInfo}/>
							<label htmlFor="source-root-db-no">No</label>

							<div className="mb-3" data-toggle-section>
								{fetchingTables && <img src="/assets/spinner-gray.svg" className="spinning-loader" alt="Loading…"/>}
								{this.showTablesList()}
							</div>

							<label htmlFor="fw-password">
								Is this a private site that&apos;s password-protected?
								<span className="tooltip">
									<img src="/assets/help.svg" className="tooltip__trigger" alt="" />
									<div className="tooltip__body">Check &quot;yes&quot; only if the source site cannot be publicly viewed without basic authentication
										(for example: the source site is a Flywheel site with Privacy Mode enabled).
									</div>
								</span>
							</label>
							<div>
								<input type="radio" id="source-pm-enabled-yes" name="source-pm-enabled" checked={httpAuth} onChange={this.toggleHttpAuth}/>
								<label className="radio" htmlFor="source-pm-enabled-yes">Yes</label>
								<input type="radio" data-hide-next id="source-pm-enabled-no" name="source-pm-enabled" checked={!httpAuth} onChange={this.toggleHttpAuth}/>
								<label htmlFor="source-pm-enabled-no">No</label>
								<div data-toggle-section>
									<div className="row">
										<div className={this.getClassName('httpauth_src_user')}>
											<Input
												type="text" 
												name="httpauth_src_user"
												title="Username"
												id="source-pm-username" 
												placeholder="Username"
												value={this.fetchValue('httpauth_src_user')}
											/>
										</div>
									</div>
									<div className="row">
										<div className={this.getClassName('httpauth_src_password')}>
											<Input
												type="password"
												title="Password"
												name="httpauth_src_password"
												id="source-pm-password"
												placeholder="Password"
												value={this.fetchValue('httpauth_src_password')}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="row hide-field">
							<Input
								type="hidden"
								name="migrate"
								value="flywheel"
								title=""
								placeholder=""
								classname=""
							/>
							<Input
								type="hidden"
								title=""
								name="type"
								placeholder=""
								classname=""
								value="sftp"
							/>
							<Input
								type="hidden"
								title=""
								name="address"
								placeholder=""
								classname=""
								value="sftp-migrations.flywheelsites.com"
							/>
							<Input
								type="hidden"
								title=""
								name="protocol"
								placeholder=""
								classname=""
								value={PROTOCOL.SFTP}
							/>
						</div>
						<div className="text-center">
							<button type="submit" className="button big-green-button">Migrate</button>
						</div>
					</div>
				</Form>
			</div>
		</div>
	}
}

FlywheelForm.propTypes = {
	handleSubmit: PropTypes.func,
	fields: PropTypes.object,
	errors: PropTypes.array,
	error: PropTypes.object,
	directoryList: PropTypes.array,
	changeSelection: PropTypes.func,
	getDirectoryList: PropTypes.func,
	fetchingDirectories: PropTypes.bool
}

export default FlywheelForm
